module.exports = __webpack_public_path__ + "static/media/Categoria3Limpieza1.41567b0d.jpg";